<div class="sk-cms-article-detail sk-cms-article-get"
    {{if style.background.styleType == 'custom'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    {{if style.titleStyle.model != 'hide'}}
        <div class="article-title {{style.titleStyle.model == 'default'?'medium':style.titleStyle.fontSize}} {{style.textWidth.model=='default'?'smallWidth':'bigWidth'}} "
        style="{{style.titleStyle.model == 'default' ? '': 'color:' + style.titleStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-color:' + style.lineStyle.color}};{{style.lineStyle.model == 'default' ? '': 'border-bottom-style:' + style.lineStyle.line}};{{style.lineStyle.model == 'hide' ? 'border-bottom:none':''}}{{style.lineStyle.model !== 'hide' ? 'padding-bottom:15px':''}};"
        sk-html="$data.title" cms-not-replace>
        {{content.title}}
        </div>
    {{/if}}
    {{if style.infoData.model != 'hide'}}
      <div class="article-data {{style.infoData.model == 'default'?'':style.infoData.fontSize2}} {{style.textWidth.model=='default'?'smallWidth':'bigWidth'}}"
      style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.color}};"
      >
        <span class="smarket icons-time"
        style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.iconColor}};"
        ></span> <span
        sk-html="$data.time" cms-not-replace
      >{{content.time}}</span>
    
        <span class="smarket icons-eye"
        style="{{style.infoData.model == 'default' ? '': 'color:' + style.infoData.iconColor}};"
        ></span> <span
        sk-html="$data.preview" cms-not-replace
        ></span>
      </div>
    {{/if}}

    {{if style.textStyle.model != 'hide'}}
        <div class="article-content {{style.textStyle.model == 'default'?'medium':style.textStyle.fontSize}} {{style.textWidth.model=='default'?'smallWidth':'bigWidth'}} "
        style="{{style.textStyle.model == 'default' ? '': 'color:' + style.textStyle.color}}"
        {{(isDesign || isPreview) ? 'sk-html=$data.body' : ''}} cms-not-replace>
        {{#content.body}}</div>
    {{/if}}
    {{if style.collectBtn.model != 'hide'}}
    <div class="foot-button-box">
         <div class="foot-button">
              <div class="btn-box" {{isDesign ? '' : "sk-event.click=handelCollect()"}} >
                <span id="btn-collect-icon" style="{{style.collectBtn.model == 'default' ? '': 'color:' + style.collectBtn.color}}" class="btn-icon icon smarket icons-shoucang1"></span>
                <div id="btn-collect" class="btn-text {{style.collectBtn.model == 'default' ? 'medium' : style.collectBtn.fontSize}}" style="{{style.collectBtn.model == 'default' ? '': 'color:' + style.collectBtn.color}}">收藏</div>
              </div>
         </div>
    </div>
    {{/if}}
    {{if !isPreview && !isDesign}}
      <div id="login_url" style="display: none">{{(content.originUrl?content.originUrl.pc:'')|raw}}</div>
    {{/if}}

</div>
